import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';

import React, { useContext } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import style from '../style.module.less';
import { Tooltip } from 'ui-components/components/tooltip';
import { TooltipContent } from 'ui-components/components/tooltip/tooltip-content';
import messages from './messages';

import ShipFrom from './component';
import { MarkAsShippedContext } from '../../../context';

const ShipFromColumnHeader = () => {
  const { shouldForceShipFrom } = useContext(MarkAsShippedContext);
  return (
    <div className={style['ship-from-column-header']}>
      <FormattedMessage {...messages.shipFrom} />
      {!shouldForceShipFrom && (
        <Tooltip position='bottom'>
          <div>
            <FontAwesomeIcon className={style['icon-wrapper']} icon={faInfoCircle} />
          </div>
          <TooltipContent>
            <FormattedMessage {...messages.shipFromDisclaimer} />
          </TooltipContent>
        </Tooltip>
      )}
    </div>
  );
};

const GetName = () => {
  const intl = useIntl();

  return intl.formatMessage(messages.shipFrom);
};

export default {
  id: 'mark-as-shipped-ship-from',
  index: 2,
  isDragable: false,
  minWidth: 100,
  width: 150,
  nonsortable: true,
  getName: GetName,
  name: <ShipFromColumnHeader />,
  render: (data) => {
    return <ShipFrom fulfillmentPlanId={data.id} />;
  },
};
